// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__h-X2B","inputWrap":"Table_inputWrap__2q-W5","col":"Table_col__1RkGe","bmiTooltip":"Table_bmiTooltip__2BIuy"};